enum previewEnum {
	alert = 'alert',
	actualite_exploitation = 'actualite_exploitation',
	actualite_marketing = 'actualite_marketing',
	footer = 'footer',
	service = 'service'
}

export default previewEnum
